// extracted by mini-css-extract-plugin
export var footer = "_p2-5";
export var fulfillmentInput = "_p2-0";
export var shipDateInput = "_p2-1";
export var shipmentModal = "_p2-2";
export var shipmentModalContent = "_p2-3";
export var tableContainer = "_p2-4";